import type { Userbot, UserbotTemplates } from "../../interfaces"

export const launchResultPath = (
  result: Userbot.LaunchResult | Userbot.ScheduledRunResult,
): string | null => {
  if ("kind" in result)
    return result.kind === "group" ? `/userbot/batches/${result.id}` : null
  return `/userbot/chains/report/${result.id}`
}

export const templateResultPath = (
  response: UserbotTemplates.TemplateRunRes,
): string | null => {
  if (response.kind === "chain") return launchResultPath(response.result)
  return response.kind === "scheduled"
    ? "/userbot/scheduled"
    : "/userbot/triggers"
}

export const launchResultMessage = (result: Userbot.LaunchResult): string => {
  if ("kind" in result)
    return result.kind === "no-work"
      ? "Нет подходящей работы"
      : `Группа создана (цепочек: ${result.total})`
  return `Цепочка «${result.name}» создана (шагов: ${result.stepsCount})`
}
